import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "heightFilled"
const HeightFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.5 22.688H4.5V20.813H19.5zM16.038 8.337 14.712 9.663 12.938 7.888V16.112L14.712 14.337 16.038 15.663 12 19.7 7.962 15.663 9.288 14.337 11.062 16.112V7.888L9.289 9.663 7.962 8.337 12 4.3zM19.5 3.188H4.5V1.312H19.5z" />
        </svg>
      }
    </span>
  )
}
export default HeightFilledIcon
